// src/api/executive/insight.api.tsx
import BaseAPI from 'api/api'
import type {
  GetInsightAgeGroupParams,
  GetInsightAvgVisitsParams,
  GetInsightCountryParams,
  GetInsightDecisionFactorsParams,
  GetInsightGenderParams,
  GetInsightNationalityParams,
  GetInsightNewPatientTrendParams,
  GetInsightNewVsExistingParams,
  GetInsightOccupationParams,
  GetInsightPromotionParams,
  GetInsightRetentionParams,
  GetInsightRevenueByChannelParams,
  GetInsightSourceChannelParams,
  GetNewPatientDetailParams,
  GetNewPatientDetailResponse,
  InsightAgeGroupResponse,
  InsightAvgVisitsResponse,
  InsightCountryResponse,
  InsightDecisionFactorsResponse,
  InsightGenderResponse,
  InsightNationalityResponse,
  InsightNewPatientTrendResponse,
  InsightNewVsExistingResponse,
  InsightOccupationResponse,
  InsightPromotionResponse,
  InsightRetentionResponse,
  InsightRevenueByChannelResponse,
  InsightSourceChannelResponse,
} from './executive.types'

const path = 'executive/insight'

export default class InsightApi extends BaseAPI {
  static async getGender(
    params: GetInsightGenderParams
  ): Promise<InsightGenderResponse> {
    const res = await BaseAPI.api.get(`${path}/gender`, { params })
    return res.data
  }

  static async getAgeGroup(
    params: GetInsightAgeGroupParams
  ): Promise<InsightAgeGroupResponse> {
    const res = await BaseAPI.api.get(`${path}/age-group`, { params })
    return res.data
  }

  static async getNationality(
    params: GetInsightNationalityParams
  ): Promise<InsightNationalityResponse> {
    const res = await BaseAPI.api.get(`${path}/nationality`, { params })
    return res.data
  }

  static async getSourceChannel(
    params: GetInsightSourceChannelParams
  ): Promise<InsightSourceChannelResponse> {
    const res = await BaseAPI.api.get(`${path}/source-channel`, { params })
    return res.data
  }

  static async getPromotion(
    params: GetInsightPromotionParams
  ): Promise<InsightPromotionResponse> {
    const res = await BaseAPI.api.get(`${path}/promotion`, { params })
    return res.data
  }

  static async getNewPatientTrend(
    params: GetInsightNewPatientTrendParams
  ): Promise<InsightNewPatientTrendResponse> {
    const res = await BaseAPI.api.get(`${path}/new-patient-trend`, { params })
    return res.data
  }

  static async getNewVsExisting(
    params: GetInsightNewVsExistingParams
  ): Promise<InsightNewVsExistingResponse> {
    const res = await BaseAPI.api.get(`${path}/new-vs-existing`, { params })
    return res.data
  }

  static async getRetention(
    params: GetInsightRetentionParams
  ): Promise<InsightRetentionResponse> {
    const res = await BaseAPI.api.get(`${path}/retention`, { params })
    return res.data
  }

  static async getAvgVisits(
    params: GetInsightAvgVisitsParams
  ): Promise<InsightAvgVisitsResponse> {
    const res = await BaseAPI.api.get(`${path}/avg-visits`, { params })
    return res.data
  }

  static async getNewPatientDetail(
    params: GetNewPatientDetailParams
  ): Promise<GetNewPatientDetailResponse> {
    const res = await BaseAPI.api.get(`${path}/new-patient-detail`, { params })
    return res.data
  }

  static async getRevenueByChannel(
    params: GetInsightRevenueByChannelParams
  ): Promise<InsightRevenueByChannelResponse> {
    const res = await BaseAPI.api.get(`${path}/revenue-by-channel`, { params })
    return res.data
  }

  static async getDecisionFactors(
    params: GetInsightDecisionFactorsParams
  ): Promise<InsightDecisionFactorsResponse> {
    const res = await BaseAPI.api.get(`${path}/decision-factors`, { params })
    return res.data
  }

  static async getCountry(
    params: GetInsightCountryParams
  ): Promise<InsightCountryResponse> {
    const res = await BaseAPI.api.get(`${path}/country`, { params })
    return res.data
  }

  static async getOccupation(
    params: GetInsightOccupationParams
  ): Promise<InsightOccupationResponse> {
    const res = await BaseAPI.api.get(`${path}/occupation`, { params })
    return res.data
  }
}
